import { useMutation } from 'react-query'
import { config } from 'config'
import { callAxios, CustomAxiosError } from 'utils/api'
import { QueryDeleteRequest, QuerySaveRequest } from 'types/saveLoadQuery'

const { SECURE_BASE_URL } = config!

const saveQuery = async (props: QuerySaveRequest): Promise<any> => {
  const { vendorNumber, userId, queryData, reportName } = props

  const { response: saveQueryResponse } = await callAxios<{ response: any }>({
    url: `${SECURE_BASE_URL}/savequery`,
    method: 'POST',
    data: {
      vendornumber: vendorNumber,
      userid: userId,
      reportname: reportName,
      querytitle: queryData.querytitle,
      query: queryData.query,
    },
  })

  return saveQueryResponse
}

export const useSaveQuery = () => {
  const {
    status: getQuerySaveStatus,
    data: addQueryData,
    error: getQuerySaveError,
    mutate: mutateSaveQuery,
    reset: resetSaveQuery,
  } = useMutation<any, CustomAxiosError, QuerySaveRequest>(saveQuery)

  return {
    getQuerySaveStatus,
    addQueryData,
    getQuerySaveError,
    mutateSaveQuery,
    resetSaveQuery,
  }
}

const deleteQuery = async (props: QueryDeleteRequest): Promise<any> => {
  const { vendorNumber, userId, queryTitle, reportName } = props

  const { response: deleteQueryResponse } = await callAxios<{ response: any }>({
    url: `${SECURE_BASE_URL}/deletequery?vendornumber=${vendorNumber}&userid=${userId}&querytitle=${queryTitle}&reportname=${reportName}`,
    method: 'DELETE',
  })

  return deleteQueryResponse
}

export const useDeleteQuery = () => {
  const {
    status: getDeleteQueryStatus,
    data: queryDeleteData,
    error: getDeleteQueryError,
    mutate: mutateDeleteQuery,
    reset: resetDeleteQuery,
  } = useMutation<any, CustomAxiosError, QueryDeleteRequest>(deleteQuery)

  return {
    getDeleteQueryStatus,
    queryDeleteData,
    getDeleteQueryError,
    mutateDeleteQuery,
    resetDeleteQuery,
  }
}
